import "../css/home.css";

export default function Home() {
	return (
		<div id="home">
			<div>
				<img
					className="right image"
					src="https://media.giphy.com/media/kEuHfnxbPIKZe99RaB/giphy.gif"
					alt="feast-gif"
				/>
				<h1>Welcome to RECIPEEE</h1>
				<hr/>
				<p className="left-description">
					Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vitae
					interdum metus. Integer blandit vitae lectus eu congue. Curabitur
					ullamcorper lacus ut dolor elementum, pulvinar dictum ante aliquam.
					Pellentesque at accumsan orci. Mauris nulla ante, bibendum et finibus
					vitae, placerat eget odio. Aliquam justo sapien, imperdiet eu
					dignissim in, ultricies non risus. Donec pretium enim vel turpis
					eleifend, non luctus neque pharetra. Phasellus sit amet odio mauris.
					Suspendisse eget libero non lacus sodales hendrerit. Etiam cursus nisl
					at lectus faucibus, quis rhoncus ligula ultricies. Pellentesque
					condimentum porttitor enim vel ultrices. Nam est sem, facilisis ac
					sapien convallis, mattis interdum augue.
				</p>
				<p className="left-description">
					Sed venenatis venenatis neque ac fringilla. Proin at porttitor lectus,
					ac pharetra tellus. Proin imperdiet sem vitae accumsan convallis.
					Phasellus vel augue dui. Sed mattis facilisis odio sed varius. Aliquam
					feugiat dui quis metus facilisis aliquam. Nullam tempor lacinia
					varius. Vivamus consectetur faucibus euismod. Nam faucibus velit
					auctor lorem congue feugiat. In lobortis lectus dapibus nunc
					tincidunt, ut consectetur velit laoreet. Sed non sapien feugiat,
					pellentesque nisl id, sagittis dolor. Morbi eu eros id metus facilisis
					dignissim. Donec ac aliquam magna. Duis vehicula lacus eu tortor
					pellentesque luctus. Vivamus id magna vehicula, laoreet orci ac,
					rhoncus dui. Aliquam nec diam molestie, sodales mauris et, congue sem.
				</p>
				<p className="left-description">
					Interdum et malesuada fames ac ante ipsum primis in faucibus. Ut et
					orci eget lorem ultricies porttitor pellentesque sed quam. Nunc
					eleifend sem et erat efficitur maximus. Phasellus id egestas quam,
					fringilla efficitur nunc. Aliquam magna est, commodo ac venenatis
					vitae, efficitur mattis mauris. Nunc sit amet velit id enim molestie
					cursus ac sed lacus. Etiam tortor ante, placerat quis ipsum at,
					vehicula euismod leo. Aenean dictum placerat justo sed posuere. Sed
					tortor ligula, consequat quis tellus vel, scelerisque commodo tortor.
					Maecenas eu elit magna. Nunc arcu nulla, placerat nec rhoncus sed,
					pharetra vitae dolor. Sed sit amet euismod tellus.
				</p>
			</div>
		</div>
	);
}
